import React from "react";


import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";


export const PrintIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue8ad'}</MuiIcon>
    );
}